module.exports = __webpack_public_path__ + "img/Loong6.94a89f30.png";